class MinecraftCraftingHeader {
  constructor (element) {
    this.element = element
    this.card = this.element.querySelector('.js-card')
    this.header = this.card.querySelector('.container')

    window.addEventListener('resize', () => {
      this.setHeadlineHeight()
    })

    this.setHeadlineHeight()
  }

  /**
   * Calculates the height of the headline area, including padding, and sets a
   * CSS variable that is used to make sure the background image clears the
   * headline text.
   */
  setHeadlineHeight = () => {
    const paddingTop = parseInt(getComputedStyle(this.element).getPropertyValue('padding-top')) || 0
    const height = parseInt(this.header.getBoundingClientRect().height) || 0
    const gap = parseInt(getComputedStyle(this.card).getPropertyValue('gap')) || 0

    this.element.style.setProperty('--headline-height', `calc(${paddingTop + height + gap}px + 20vw)`)
  }
}

export default {
  selector: '.js-minecraft-crafting-header',
  Source: MinecraftCraftingHeader
}
